/* eslint-disable func-names */
import {
  GRAPH_THEMES_SETTINGS,
  THEMES,
  CHART_THEMES_PARAMS,
} from '@config/Consts';

const botsGraphTemplate = {
  aria: {
    show: true,
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      lineStyle: {
        opacity: 0.5,
      },
    },
  },
  legend: {
    bottom: '10',
    textStyle: {
      color: GRAPH_THEMES_SETTINGS[THEMES.DARK][CHART_THEMES_PARAMS.LEGEND_TEXT_COLOR],
      // color: '#fcfcfd',
    },
    tooltip: {
      show: true,
      trigger: 'item',
      textStyle: {
        width: '50px',
      },
    },
    data: [],
  },
  grid: {
    top: '5',
    left: '50',
    right: '20',
    bottom: '55',
    containLabel: false,
    backgroundColor: 'rgba(128, 128, 128, 0.1)', // no need beautification
  },
  xAxis: {
    type: 'time',
    boundaryGap: false,
    data: [],
    axisLabel: {
      color: GRAPH_THEMES_SETTINGS[THEMES.DARK][CHART_THEMES_PARAMS.AXIS_LABEL_COLOR],
      showMaxLabel: false,
      showMinLabel: false,
    },
    axisTick: {
      show: false,
    },
    axisLine: {
      lineStyle: {
        color: GRAPH_THEMES_SETTINGS[THEMES.DARK][CHART_THEMES_PARAMS.AXIS_LINE_COLOR],
      },
    },
    splitLine: {
      show: false,
    },
  },
  yAxis: {
    type: 'value',
    splitLine: {
      show: false,
    },
    axisLine: {
      lineStyle: {
        color: GRAPH_THEMES_SETTINGS[THEMES.DARK][CHART_THEMES_PARAMS.AXIS_LINE_COLOR],
      },
    },
    axisLabel: {
      color: GRAPH_THEMES_SETTINGS[THEMES.DARK][CHART_THEMES_PARAMS.AXIS_LABEL_COLOR],
    },
  },
  series: [],
};

export default botsGraphTemplate;
